export default "__VITE_ASSET__aff9e8a2__"